
import EditableToggleBlock from '@/components/EditableToggleBlock.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import { defineComponent, PropType, reactive, toRefs } from 'vue'
import { CtPacking } from '@/models/interfaces/content-type'
import AddIcon from '@/components/Icons/AddIcon.vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import ListHeader from '@/components/ListHeader.vue'
import useContentModule from '@/pages/composables/useContentModule'
import { useStore } from 'vuex'
import { Entry } from '@Protium/vue-ozone-utils'
import DButton from '@/components/base/DButton.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import DfTooltip from '@/components/base/DfTooltip.vue'
import InfoIcon from '@/components/Icons/InfoIcon.vue'

interface FulfillmentPricingState {
  packingDialog: {
    [key: string]: boolean,
  },
  selection: Array<string>,
  collection: CtPacking[]
}

export default defineComponent({
  name: 'FulfillmentPricing',
  components: { ListHeader, CloseIcon, AddIcon, CurrencyInput, EditableToggleBlock, DButton, EditableBlockInput, DfTooltip, InfoIcon },

  props: {
    packing: {
      type: Array as PropType<Array<CtPacking>>
    },
    catalogue: {
      type: Object
    },
    readonly: {
      type: Boolean
    }
  },

  setup (props) {
    const $store = useStore()
    const { model, requestHandler } = useContentModule<CtPacking>('Packing', $store)

    const state: FulfillmentPricingState = reactive({
      packingDialog: {
        show: false,
        loading: false
      },
      selection: [],
      collection: [],
    })

    function addPrice (editState, editingRef) {
      const res = state.selection.reduce((acc, curr) => (editState.fulfillment_prices?.[curr] ? acc[curr] : acc[curr] = 0, acc), {})
      editState.fulfillment_prices = { ...editState.fulfillment_prices, ...res }
      editingRef.value = true
      packingValues(editState)
    }

    function removePrice (packingValue, $event, editState, editingRef) {
      if (packingValue.sys.id) {
        delete editState.fulfillment_prices[packingValue.sys.id]
      }
      editingRef.value = true
      packingValues(editState)
    }

    function showSelect (editState) {
      filteredCollection(editState)
      state.packingDialog.show = true
    }

    function filteredCollection (editState) {
      state.collection = (props.packing || []).filter(item => {
        const fulfillmentPricesKeys = Object.keys(editState.fulfillment_prices || [])
        const itemId = item.sys?.id
        const itemId2 = item.id

        const includesId = fulfillmentPricesKeys.includes(itemId)
        const includesId2 = fulfillmentPricesKeys.includes(itemId2)

        return !includesId && !includesId2
      })
    }

    function select (item: Entry) {
      const index = state.selection.findIndex(s => s === item?.sys?.id)
      if (index >= 0) {
        state.selection.splice(index, 1)
      } else {
        state.selection.push(item.sys?.id)
      }
    }

    function combinedPriceAndPacking (editState) {
      return Object.keys(editState?.fulfillment_prices || []).map((key) => {
        const value: Entry | undefined = (props.packing || []).find(i => i.sys?.id === key || i.id === key)
        return !value ? null : {
          ...value,
          price: (editState?.fulfillment_prices || {})[key]
        }
      }).filter(Boolean)
    }

    function updatePackingValue (item, $event, editState, editingRef) {
      if (editState) {
        editState.fulfillment_prices[item.sys?.id] = $event
      }
      editingRef.value = true
    }

    const packingValues = (editState) => combinedPriceAndPacking(editState)

    return {
      ...toRefs(state),
      packingValues,
      updatePackingValue,
      select,
      addPrice,
      removePrice,
      showSelect,
      filteredCollection,
      requestHandler,
      model,
    }
  }
})
